module.exports = __webpack_public_path__ + "img/share-icon-selected.13f2d5df.svg";